import nextApi from "./next-api";

const getBanners = () => {
  return nextApi.get("cms/banners");
};

const createBanner = (data) => {
  return nextApi.post("cms/banners", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateBanner = (id, data) => {
  return nextApi.put(`cms/banners?id=${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteBanner = (id) => {
  return nextApi.delete(`cms/banners?id=${id}`);
};

const BannerService = {
  getBanners,
  createBanner,
  updateBanner,
  deleteBanner,
};

export default BannerService;
